// extracted by mini-css-extract-plugin
export default {"Breadcrumbs":"breadcrumbs_Breadcrumbs__tw3-b","item":"breadcrumbs_item__4scph","more":"breadcrumbs_more__2Ha8b","Route":"breadcrumbs_Route__51teq"};